import React, { Component } from 'react';
// import { Button, Icon, Form, Segment, Menu, Input, Radio } from 'semantic-ui-react';
import { Segment, Menu, Icon, Button } from 'semantic-ui-react';
import { SpectrogramContext } from './spectrogram-provider';

import Slider from 'rc-slider';

import '../styles/slider-styles.css';

// import Slider from 'react-rangeslider';
// To include the default styles
// import 'react-rangeslider/lib/index.css';

import '../styles/volume-settings.css';


// Class the renders the Scale Controls when the button is pushed
class VolumeSettings extends Component {

  constructor(props) {
    super(props);
    this.state = {
      right: '0px'
    }
  }

  render() {
    return (
      <SpectrogramContext.Consumer>
        {(context) => (
          <React.Fragment>
            <Segment className="menu-pane-container compact volume-container" style={{ right: this.state.right }}>
              {/** Volume Settings **/}
              <div className="vert">
                {/* Microphone Gain */}
                <Menu.Item className="microphone-positioning volume-controls">
                  <Icon name="microphone" />
                  {/* <div className = "slider-label"> Microphone Gain </div> */}
                  <Slider
                    min={1}
                    max={100}
                    value={context.state.microphoneGain}
                    onChange={context.handleGainChange}
                    tooltip={false}
                    className="slider"
                  />
                </Menu.Item>

                {/* Output Volume */}
                <Menu.Item className="volume-controls">
                  <Icon name="volume up" />
                  {/* <div className="slider-label"> Output Volume</div> */}
                  <Slider
                    min={1}
                    max={100}
                    value={context.state.outputVolume}
                    onChange={context.handleOutputVolumeChange}
                    tooltip={false}
                    className="slider"
                  />
                  {/* <div>
                      {this.props.outputVolume}
                    </div> */}
                </Menu.Item>

                {/* Frequency Definition */}
                <Menu.Item className="volume-controls freq-definition-control">
                  <div className="freq-def-label">
                    <span className="freq-def-title">Frequency Definition</span>
                    <Slider
                      min={1}
                      max={7}
                      step={1}
                      value={[512, 1024, 2048, 4096, 8192, 16384, 32768].indexOf(context.state.fftSize) + 1}
                      marks={{ 1: '86', 2: '43', 3: '22', 4: '11', 5: '5', 6: '3', 7: '1' }}
                      className="slider"
                      onChange={(val) => context.handleFftSizeChange([512, 1024, 2048, 4096, 8192, 16384, 32768][val - 1])}
                    />
                    <span className="freq-def-unit">(Hz)</span>
                  </div>
                </Menu.Item>
              </div>
              <div className="volume-close-menu">
                <Button icon onClick={this.props.closeMenu} className="close-menu">
                  <Icon fitted name="angle double up" size="large" />
                </Button>
              </div>
            </Segment>
          </React.Fragment>
        )}
      </SpectrogramContext.Consumer>
    );
  }
}

VolumeSettings.contextType = SpectrogramContext;

export default VolumeSettings;
